import { AdminVideoParticipantAssignmentDto, ParticipantDto, VideoParticipantTypeDto } from '../../../types/admin.types';

const formatNzDate = (value: string) => {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;

    const parts = new Intl.DateTimeFormat('en-NZ', {
        timeZone: 'Pacific/Auckland',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    }).formatToParts(date);
    const part = (type: Intl.DateTimeFormatPartTypes) => parts.find((item) => item.type === type)?.value;
    const day = part('day');
    const month = part('month');
    const year = part('year');
    return day && month && year ? `${day}-${month}-${year}` : null;
};

const cornerRank = (corner?: string | null) => {
    if (corner === 'red') return 0;
    if (corner === 'blue') return 1;
    return 2;
};

export const generateAdminFightTitle = (
    effectiveDate: string | null,
    fightNumber: number | null,
    assignments: AdminVideoParticipantAssignmentDto[],
    participants: ParticipantDto[],
    participantTypes: VideoParticipantTypeDto[] = []
): string | null => {
    if (!effectiveDate || !fightNumber || fightNumber < 1) return null;
    const formattedDate = formatNzDate(effectiveDate);
    if (!formattedDate) return null;

    const participantById = new Map(participants.map((participant) => [participant.Id, participant]));
    const participantTypeById = new Map(participantTypes.map((type) => [type.Id, type.Name.trim().toLowerCase()]));
    const seenParticipantIds = new Set<string>();
    const namedAssignments = assignments
        .map((assignment, index) => ({
            assignment,
            index,
            name: participantById.get(assignment.ParticipantId)?.Name?.trim() ?? '',
            preferredRole: ['fighter', 'competitor'].includes(participantTypeById.get(assignment.TypeId) ?? '')
        }))
        .filter((item) => item.name)
        .sort((left, right) => (
            Number(right.preferredRole) - Number(left.preferredRole)
            || cornerRank(left.assignment.CornerColor) - cornerRank(right.assignment.CornerColor)
            || left.index - right.index
        ))
        .filter((item) => {
            if (seenParticipantIds.has(item.assignment.ParticipantId)) return false;
            seenParticipantIds.add(item.assignment.ParticipantId);
            return true;
        });

    if (namedAssignments.length < 2) return null;
    return `${formattedDate} FIGHT ${fightNumber} ${namedAssignments[0].name.toUpperCase()} v ${namedAssignments[1].name.toUpperCase()}`;
};
